/* Shared new-chat greeting (<Salutation>). Loaded by the dashboard SPA
   directly and inlined into the widget's shadow DOM.

   The two surfaces name their tokens differently — the SPA has --strong-ink /
   --font-display, the widget has --nw-text inside its shadow root — so every
   colour and face here falls back through both and finally to `inherit`. That
   keeps one stylesheet honest on both surfaces and in both themes without a
   hardcoded hex.

   Size is a token rather than a fixed clamp: the SPA's heading scales with the
   viewport, but the widget is a ~380px panel whose text must not track the
   window it floats over. */
.nw-hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 8px;
}

.nw-hello-line {
  display: inline-flex;
  align-items: center;
  gap: var(--nw-hello-gap, 13px);
  margin: 0;
  font-family: var(--font-display, inherit);
  font-size: var(--nw-hello-size, clamp(23px, 3.2vw, 33px));
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: var(--strong-ink, var(--nw-text, inherit));
  /* A long "Good afternoon, Someone-With-A-Long-Name" wraps instead of
     pushing the panel into a horizontal scroll. */
  text-wrap: balance;
  overflow-wrap: anywhere;
}

/* Sized against the heading's own font-size so the mark scales with the
   size token above instead of shrinking away on a wide screen. */
.nw-hello-line > svg,
.nw-hello-line > .logo {
  width: 1.15em;
  height: 1.15em;
  flex: none;
}

.nw-hello-sub {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--nw-text-secondary, var(--muted-ink, inherit));
}
